import {
  ICompleteAuthorizationRequest,
  ICompleteAuthorizationResponse,
} from "../@types/OAuth";
import { ensureOk } from "../utils/ensureOk";
import { ANONYMOUS_REQUEST, api } from "./api";

export const dexcomService = {
  async completeAuthorization(
    request: ICompleteAuthorizationRequest
  ): Promise<ICompleteAuthorizationResponse> {
    // Anonymous callback page (EN-5229): always the default API, never the
    // regional URL a previous sign-in left in browser storage.
    // ensureOk: the interceptor resolves errors (and `undefined` when nothing
    // came back), so without it the page would read an error body as success.
    return ensureOk(
      await api.post<ICompleteAuthorizationResponse>(
        "/Mobile/Dexcom/CompleteAuthorization",
        request,
        ANONYMOUS_REQUEST
      )
    );
  },
};
